/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/label-has-associated-control */
import { useEffect, useState, ChangeEvent } from 'react';
import { useTranslation } from 'react-i18next';
import InputCheckboxUnform from './InputCheckboxUnform';

interface Props {
  name: string;
  id: string;
  defaultChecked: boolean;
}
const Texto = (textoToReplace: any) => {
  const { t } = useTranslation();
  return (
    t(`aplicacoes.${textoToReplace}`)
  );
};
const Switch = ({
  name, id, defaultChecked,
}: Props) => {
  const [checked, setChecked] = useState<boolean>(defaultChecked);

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => (
    setChecked(e.target.checked)
  );

  useEffect(() => {
    setChecked(defaultChecked);
  }, [defaultChecked]);

  return (
    <div className="custom-control custom-switch">
      <InputCheckboxUnform
        className="custom-control-input"
        checked={checked}
        type="checkbox"
        name={name}
        id={id}
        onChange={handleChange}
      />
      <label className="custom-control-label" htmlFor={id}>
        {checked ? Texto('form.habilitado') : Texto('form.desabilitado')}
      </label>
    </div>
  );
};

export default Switch;
